import Api from "@/api/api.js";

export default {
  async saveModeleAnalyse(data) {
    return await Api().post("/parametres/models-analyses", data);
  },  
  async updateModeleAnalyse(id, data) {
    return await Api().put(`/parametres/models-analyses/${id}`, data);
  },
  getModelsAnalyses(params = {}) {
    const promise = Api().get("/parametres/models-analyses", { params: params });
    return promise.then((response) => response.data);
  },
  deleteModeleAnalyse(id) {
    const promise = Api().delete(`/parametres/models-analyses/${id}`);
    return promise.then((response) => response.data);
  },
  activateDeactivateModeleAnalyse(id) {
    const promise = Api().put(
      `/parametres/models-analyses/${id}/activate-deactivate`
    );
    return promise.then((response) => response.data);
  },
};
